import { txTypePretty } from "./TransactionTypeIcon";

const csvEscape = (v) => {
  if (v == null) return "";
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const exportTransactionsCsv = (rows, filename) => {
  const headers = ["Date", "Contract", "Milestone", "Counterparty", "Direction", "Type", "Amount", "Currency", "Status"];
  const body = rows.map((t) => [
    t.created_at,
    t.contract_title || "",
    t.milestone_title || "",
    t.counterparty_name || "",
    t.direction || "",
    txTypePretty(t.type),
    t.amount,
    t.currency || "USD",
    t.status || "Complete",
  ].map(csvEscape).join(","));
  const csv = [headers.join(","), ...body].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
};
